<template>
  <v-container class="mt-6" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <div class="pa-2">
      <v-row>
        <v-col cols="12">
          <p class="white--text">
            The Editor saves a new Release with the status of unpublished. Use
            the Recents area to show this on the website or to subscribers. The
            Editor does not change the status of an already published News
            Release, only the content.
          </p>
        </v-col>
      </v-row>
      <!--  -->
      <template>
        <div class="text-center">
          <v-dialog dark v-model="datepick_show" width="350">
            <v-card>
              <v-card-text>
                <v-date-picker
                  dark
                  v-model="picker"
                  v-if="datepick_show"
                ></v-date-picker>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="accent" text @click="datepick_show = false">
                  Done
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>

      <v-row>
        <v-col cols="12" md="6">
          <div class="d-flex flex-row justify-start">
            <v-icon
              class="cmpbk_lght white--text mr-1"
              style="position: relative; top: 20px; max-height: 24px"
              @click="toggle_picker"
              >$calendar</v-icon
            >

            <v-text-field
              v-mask="'##/##/####'"
              dark
              id="create_date"
              maxlength="10"
              v-model="edit_release.news_date"
              :counter="12"
              label="News Date"
              required
              @change="sync2pick"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            dark
            class="cmpbk_lght white--text"
            maxlength="500"
            v-model="edit_release.news_title"
            :counter="500"
            label="Title"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <label class="white--text">Release Text</label>
          <tiptap></tiptap>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <button
            class="pa-2"
            style="background-color: #1fdeb0; color: black; border-radius: 4px"
          >
            <v-icon small mr-1 title="Save Release">$save</v-icon>
            Save Release
          </button>
          <button
            class="pa-2 ml-2"
            style="background-color: #1fdeb0; color: black; border-radius: 4px"
          >
            <v-icon small mr-1 title="Save Release">$cancel</v-icon>
            Cancel
          </button>
          <!-- <v-btn class="accent black--text ml-1 mt-1" @click="save()">
            <v-icon small mr-1 title="Save Release">$save</v-icon>
            Save
          </v-btn>
          <v-btn
            class="accent black--text ml-1 mt-1"
            @click="cancel()"
            style="background-color: red !important"
          >
            <v-icon small mr-1 title="Cancel release">$cancel</v-icon>
            Cancel
          </v-btn> -->
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import tiptap from "./tiptap.vue";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "add_edit",
  mixins: [bus_common],
  components: { tiptap },
  data: () => ({
    picker: "",
    datepick_show: false,
    customTheme: {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      dark: false,
      themes: {
        light: {
          primary: "#FF5722", // Custom primary color
          secondary: "#03A9F4", // Custom secondary color
          background: "#0d1117",
          accent: "#1fdeb0",
          accent2: "#f04336",
          error: "#f44336",
          warning: "#ff9800",
          info: "#03a9f4",
          success: "#4caf50",
          cmpbk_lght: "#363C43",
          cmpbk_drk: "#21262d",
          whitesmoke: "#f5f5f5",
          blacky: "#282623",
          rpdblue: "#00334a",
        },
      },
    },
    edit_release: {},
    valid: false,
    firstname: "",
    lastname: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 10 || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  watch: {
    "$store.state.releasex": function () {
      //keep this
      let self = this;
      this.init();
    },
    picker: function () {
      this.edit_release.news_date = this.format_date_us(this.picker).toString();
    },
  },
  methods: {
    sync2pick() {
      this.picker = this.format_date_sql(
        this.edit_release.news_date
      ).toString();
    },
    toggle_picker() {
      this.datepick_show = !this.datepick_show;
    },
    message1() {
      alert("This button does nothing yet.");
    },
    save() {},
    cancel() {},
    init() {
      this.show_loader(false);
      this.edit_release = this.mno(this.$store.state.releasex);
      this.picker = this.edit_release.news_date;
      // this.$nextTick(() => {
      //   this.edit_release.news_date = this.format_date_sql(
      //     this.edit_release.news_date
      //   );
      // });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
